module.exports = __webpack_public_path__ + "assets/3adc4d153dba4c791b00838e53dc0410.svg";